import React from 'react';
import { InputTuKhoa } from 'modules/reception/form-timkiem';
import { Button } from '@blueprintjs/core';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Reception } from 'api';
import {DropDown} from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { DatePicker } from 'components/tt-forms/common';

let classNames = require('classnames');

class FormTimKiemNangCao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      searchKey: '',
      receptionType: '',
      tinhTrangXuLy: '',
      ketQuaTiepDan: '',
      lanhDaoTiepDan: '',
      listKetQuaTiepDan: [],
      tinhTrangXuLyList: [],
      startDate: '',
      endDate: '',
      searching: this.props.searching,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    };
  }
  componentDidMount() {
    let key = 'dk';
    if (this.props.type === 'DOT_XUAT') {
      key = 'dx';
    }
    let data = localStorage.getItem(key+'Data') ? JSON.parse(localStorage.getItem(key+'Data')) : {};
    this.state.searchKey = data.tuKhoa || '';
    if (data.advanceSearch) {
      this.state.receptionType = data.phanLoaiDon || '';
      this.state.tinhTrangXuLy = data.tinhTrangXuLy || '';
      this.state.ketQuaTiepDan = data.ketQuaTiepDan || '';
      this.state.lanhDaoTiepDan = data.lanhDaoId || '';
      this.state.startDate = data.startDate ? new Date(data.startDate) : '';
      this.state.endDate = data.endDate ? new Date(data.endDate) : '';
    }
    this.setState({...this.state});
    this.getKetQuaTiepDan();
  }

  handleSearch(e) {
    e.preventDefault();

    if (!this.props.advanceSearch) {
      this.setState({
        doSearch: true
      });
      this.props.handleSearch(this.state, e);
    } else {
      if(this.validateSubmitForm()) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      }
    }

    return;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  componentWillUnmount() {

  }

  cancel(e) {
    this.props.onCancel(e);
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleChangeData(name, e) {
    this.setState({
      [name]: e.target.value
    });
    this.getTinhTrangXuLy(e.target.value);
    if (name === 'ketQuaTiepDan') {
      this.setState({tinhTrangXuLy: ''});
    }
  }

  getTinhTrangXuLy(id) {
    Reception.actions.getTinhTrangXuLy.request(null, {
      ketQuaTiepDan: id
    }).then(res => {
      if (res.data) {
        this.setState({
          tinhTrangXuLyList: res.data
        });
      } else {
        this.setState({
          tinhTrangXuLyList: []
        });
      }
    });
  }
  getKetQuaTiepDan() {
    Reception.actions.getKetQuaTiepDanSearch.request().then(res => {
      if (res.data) {
        this.setState({
          listKetQuaTiepDan: res.data
        });
      } else {
        this.setState({
          listKetQuaTiepDan: []
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searching: nextProps.disabled,
      doSearch: nextProps.search
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  render() {
    let classes = ['btn-green', 'tt-search'];

    if (this.state.searching) {
      classes.push('btn-disable');

      if (this.state.doSearch) {
        classes.push('btn-loading');
      }
    }

    let btnClasses = classNames(classes);
    // this.state.tableLoading ? (this.state.searching ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"
    return (
      <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
        <div className="rows">
          <div className="col-9 no-gutter">
            <InputTuKhoa onChange={ this.handleChange.bind(this, 'searchKey') } value={this.state.searchKey} />
            <DatePicker label='Tiếp nhận từ ngày' bindValidator={this} value={this.state.startDate} channel="formTaoDon" endDate={ this.state.endDate } onChange={ this.handleChangeDate.bind(this, 'startDate') } />
            <DatePicker label='Đến ngày' bindValidator={this} value={this.state.endDate} channel="formTaoDon" startDate={ this.state.startDate } onChange={ this.handleChangeDate.bind(this, 'endDate') } />
            <div className="clear-left">
              <DropDown label="Lãnh đạo tiếp dân" selectedValue={this.state.lanhDaoTiepDan} options={this.props.lanhDaoList} valueName="hoVaTen" keyName="congChucId" placeholder={{key:'',text: '--Chọn--'}} className="input-group col-25" onChange={ this.handleChange.bind(this, 'lanhDaoTiepDan') } />
            </div>

            <DropDown className="input-group col-25" onChange={ this.handleChangeData.bind(this, 'ketQuaTiepDan') } options={this.state.listKetQuaTiepDan} placeholder={{key:'',text: '--Chọn--'}} valueName="ten" keyName="giaTri" label="Kết quả tiếp dân" selectedValue={this.state.ketQuaTiepDan}/>
            <ShowIf condition={this.state.ketQuaTiepDan}>
              <DropDown selectedValue={this.state.tinhTrangXuLy} valueName="ten" keyName="giaTri" className='input-group col-25' options={ this.state.tinhTrangXuLyList } onChange={ this.handleChange.bind(this, 'tinhTrangXuLy') } label="Tình trạng xử lý" placeholder={{key:'',text: '--Chọn--'}} />
            </ShowIf>
            <DropDown selectedValue={this.state.receptionType} valueName="ten" keyName="giaTri" className='input-group col-25' options={ this.props.loaiDonThu } onChange={ this.handleChange.bind(this, 'receptionType') } label="Phân loại đơn" placeholder={{key:'',text: '--Chọn--'}} />
          </div>
          <div className="col-3 padding-button">
            <div className="btn-wrap full-input-seacrh">
              <Button className={ btnClasses } text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
            </div>
            <div className="input-group full-input-seacrh">
              <Link className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" }
                onClick={ this.cancel.bind(this) }><i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao</Link>
            </div>
          </div>
        </div>
      </form>
      );
  }
}

FormTimKiemNangCao.defaultProps = {
  validators: {},
  handleSearch: function() {
    console.log('Please assign handleSearch() method');
  },

  disabled: false,
  searching: false,
  loaiDonThu: []
}

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    loaiDonThu: state.duLieuHeThong.loaiDonThu
  };
}

export default connect(bindStateToProps)(FormTimKiemNangCao);



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/form-timkiem/form-nangcao.jsx